import { Error, Label, TextareaBlock, TextareaElement, TextareaGroup } from "./style";

// Многострочное поле в стиле InputComponent (подпись внутри рамки, ошибка под полем).
const Textarea = ({
  value,
  onChange = () => null,
  onBlur = () => null,
  placeholder = null,
  required = false,
  label = null,
  touched = false,
  error = null,
  disabled,
  rows = 4,
  maxLength,
  ...rest
}) => (
  <TextareaGroup>
    <TextareaBlock isError={touched && error}>
      {label && (
        <Label>
          {label} {required && <span>*</span>}
        </Label>
      )}
      <TextareaElement
        value={value}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        {...rest}
      />
    </TextareaBlock>
    {touched && error && <Error>{error}</Error>}
  </TextareaGroup>
);

export default Textarea;
